import { Box, Divider } from "@mui/material";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { goLink, rem } from "assets/js/common";
import axios from "axios";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";
import Loading from "components/ui/loading";
import { useHistory } from "react-router-dom";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export default function Push() {
  const dispatch = useDispatch();
  const history = useHistory();

  const [pushList, setPushList] = useState([]);
  const [fetching, setFetching] = useState(false);

  const { accessiblePages } = useSelector((state) => state.user);
  const { init } = useSelector((state) => state.top);

  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "알림함", menu: false }));
  }, [init]);

  useEffect(() => {
    // fetchData();
    getNotiList();
  }, []);

  window.appBackKeyHandle = () => {
    history.goBack();
  };

  window.appNotiList = (os, jsonStr) => {
    setFetching(false);
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ios
    ) {
      jsonStr = decodeURIComponent(jsonStr);
    } else {
      jsonStr = decodeURIComponent(decodeURI(jsonStr).replace(/\+/g, " "));
    }
    jsonStr = jsonStr.replace(/(?:\r\n|\r|\n)/g, "<br/>");
    let jsonObj = JSON.parse(jsonStr);
    setPushList(jsonObj);
  };

  const getNotiList = () => {
    if (window.Android) {
      window.Android.getNotiList();
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ios
    ) {
      // Call iOS interface
      var message = {
        command: "getNotiList",
      };
      window.webkit.messageHandlers.ios.postMessage(message);
    }
  };

  const fetchData = () => {
    return new Promise((resolve) => {
      setFetching(true);
      getNotiList();
      resolve(true);
      // axios
      //   .get("/api/pn/push")
      //   .then((res) => {
      //     setPushList(res.data.data.pushList);
      //     resolve(res.data.data.pushList);
      //     setFetching(false);
      //   })
      //   .catch((error) => {
      //     setFetching(false);
      //   });
    });
  };

  const checkLink = (item) => {
    let link = item.link;
    const token = cookies.get("X-AUTH-TOKEN");
    // if (item.linkTp == "1") history.push(item.link);
    // else goLink(item.link);

    if (link) {
      if (link.indexOf("/") == 0) {
        let find = accessiblePages.find((page) => link.indexOf(page) > -1);
        if (find) {
          history.push(link);
        } else {
          if (token) {
            history.push(link);
          } else {
            dispatch(loadAlert(true));
          }
        }
      } else {
        goLink(link);
      }
    }
  };

  return (
    <>
      <Loading open={fetching} />
      <PullToRefresh
        onRefresh={fetchData}
        pullingContent={false}
        refreshingContent={<Spinner />}
      >
        <div className="PushList container nopad">
          {pushList.length == 0 ? (
            <div className="nodata-wrap">
              <div
                className="nodata"
                style={{
                  height: "auto",
                  margin: `${rem(202)} ${rem(0)} ${rem(6)}`,
                }}
              >
                <Box className="illust">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`}
                  />
                </Box>
                <p className="color-info">받은 알림이 없습니다.</p>
              </div>
              <div className="push-info">
                <div className="color-info-sm">
                  발송일로부터 7일이 지난 알림은 자동 삭제됩니다.
                </div>
              </div>
            </div>
          ) : (
            <ul>
              {pushList.map((item, i) => (
                <Fragment key={i}>
                  <li
                    className="push-item"
                    onClick={() => {
                      if (item.link) checkLink(item);
                    }}
                    style={{
                      backgroundColor: !item.view && "#FFF4F2",
                    }}
                  >
                    {item.noti == "1" ? (
                      <div className="icon-notice" />
                    ) : (
                      <div className="icon-event" />
                    )}

                    <h2 className="h2">{item.title}</h2>
                    <div
                      className="cont"
                      dangerouslySetInnerHTML={{
                        __html: item.message ? item.message : "",
                      }}
                    />
                    <div className="date">{item.date}</div>
                    {item.link && <div className="link" />}
                  </li>
                  <Divider />
                </Fragment>
              ))}
              <li className="push-info">
                <div className="color-info-sm">
                  발송일로부터 7일이 지난 알림은 자동 삭제됩니다.
                </div>
              </li>
            </ul>
          )}
        </div>
      </PullToRefresh>
    </>
  );
}
